(function () {
  "use strict";

  function initYotpo() {
    try {
      if (window.yotpo && typeof window.yotpo.initWidgets === "function") {
        window.yotpo.initWidgets();
      }
    } catch (e) {
      // fail silently
    }
  }

  // 1) Initial page load (Expanse event)
  document.addEventListener("page:loaded", initYotpo);

  // 2) Theme editor refresh
  document.addEventListener("shopify:section:load", initYotpo);

  // 3) Robust: re-init when collection grid changes (filters/sort/infinite scroll)
  function watchCollectionGrid() {
    var grid =
      document.querySelector(".collection-grid") ||
      document.querySelector("[data-section-type*='collection'] .product-grid") ||
      document.querySelector(".product-grid");

    if (!grid) return;

    var observer = new MutationObserver(function (mutations) {
      // Only re-init if nodes were added (grid re-render)
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
          initYotpo();
          break;
        }
      }
    });

    observer.observe(grid, { childList: true, subtree: true });
  }

  document.addEventListener("page:loaded", watchCollectionGrid);
})();
